module.exports = "/fonts/fa-regular-400.svg?4a51612847ed0cf06db0f3b86180e93d";